import { render, staticRenderFns } from "./UnitWorkOutputNoteModal.vue?vue&type=template&id=0809c896&scoped=true"
import script from "./UnitWorkOutputNoteModal.vue?vue&type=script&lang=js"
export * from "./UnitWorkOutputNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809c896",
  null
  
)

export default component.exports